module.exports = __webpack_public_path__ + "static/img/rest51.e7aff52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rest51.jpg
// module id = h/R3
// module chunks = 0